import React from "react";
import { useResourceContext } from "react-admin";
import { StyledButton } from "./ListShowButton";

interface ListEditButtonProps {
  record: any;
}

const ListEditButton: React.FC<ListEditButtonProps> = ({ record }) => {
  const resource = useResourceContext();

  return (
    <StyledButton variant="outlined" href={`/#/${resource}/${record.id}`}>
      EDIT
    </StyledButton>
  );
};

export default ListEditButton;
